<template>
  <div>
    <RefreshResults
      v-if="showRefreshNotification"
      :type="'hotel'"
      @clearResults="clearResults"
      @refreshSearch="refreshSearch"
    />
    <div v-else>
      <div
        :style="
          meetingHotelsResults ? 'margin: auto; padding: 0px !important' : ''
        "
      >
        <!-- <b-progress
          v-if="resultProgress < 100"
          type="is-cream"
          size="is-small"
          :value="resultProgress"
          style="width: 100%; margin: auto; margin-bottom: 15px;"
        ></b-progress> -->

        <div v-if="items.length > 0">
          <div v-if="filteredItems">
            <div
              v-if="!(filteredItems.length > 0) && !loading"
              style="text-align: center;"
            >
              <b-message aria-close-label="Close message">
                No results found for this search <br />
                <br />
                Try removing some filters to see more results <br />
                <br />
                <a @click="setDefaultFilters()">Restore defaults</a>
              </b-message>
            </div>
          </div>

          <div class="mt-1 mb-2" :class="pathMixin_isMeeting ? 'box' : ''">
            <HotelFiltersDropdowns
              v-model="filters"
              :sortOptions="sortOptions"
              :availableChains="availableChains"
              :preferredChains="preferredVendors"
              :filteredChains="filteredChains"
              :fullAmenities="fullAmenities"
              :filteredAmenities="filteredAmenities"
              :vendorsChains="$globals.vendors.hotelChains"
              :mapView="mapView"
              :priceRange="priceRange"
              :sliderData="sliderData"
              :availablePolicies="availablePolicies"
              :highlights="highlightedFilters"
              :originalPriceRange="originalPriceRange"
              @clearFilters="setDefaultFilters()"
              @resetFilter="resetFilter"
            />
          </div>
          <div
            class="pl-4 pr-4 pt-4"
            :class="windowWidth >= bookingFixedWidth ? 'bookingFixed' : ''"
          >
            <div v-if="mapView" style="margins: auto;">
              <GMapView
                :lat="parseFloat(formData.loc.lat)"
                :long="parseFloat(formData.loc.lng)"
                :formData="formData"
                :locations="filteredItems"
                :imageDict="hotelImages"
                :addingData="addingData"
                @selected="selectedByMap"
                @setLiveData="setLiveData"
              />
            </div>
            <div v-else data-test="hotel_results_list">
              <div
                v-for="(result, index) in filteredItems"
                :key="result.hotelCode"
                class="h-result"
                data-test="h_result"
              >
                <HResult
                  v-bind:class="{
                    grayout: roomsCount(result) == 0,
                  }"
                  :formData="formData"
                  :solution="result"
                    :preferredVendors="preferredVendors"
                  :session="session"
                  :autoloadPrice="index < maxItemsToAutoload ? true : false"
                  :image="parseImage(result)"
                  :roomsProp="result.rooms"
                  :cheapestPriceProp="result.cheapestPrice"
                  :selected="selectedHotelCode === result.hotelCode"
                  @setLiveData="setLiveData"
                  :filters="{
                    //price: maxPrice,
                    beds: bedFilters,
                    breakfast: breakfastIncluded,
                    guaranteeType: guaranteeType,
                  }"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="loading">
          <div v-for="(result, index) in skelItems" :key="index" class="field">
            <ResultSkele />
          </div>
        </div>
      </div>

      <b-message
        v-if="additionalItems.length > 0"
        style="text-align: center; position:fixed; width: 275px; font-size: 12px; right: 50px !important; top: 70px !important; padding: 0; z-index: 100;"
        type="is-info is-light"
      >
        We have {{ additionalItems.length }} more hotels for your search. <br />
        <a @click="expandResults()">See full results </a>
      </b-message>

      <SearchErrorMessage
        v-if="showErrors"
        :errors="errors"
        :userPayload="null"
        :code="null"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
let intersection = require("lodash.intersection");
import { mapState } from "vuex";
import bookingMixin from "../../../mixins/bookingMixin";
import SearchErrorMessage from "@/components/BookTravel/SearchErrorMessage.vue";
import HResult from "./HResult";
import ResultSkele from "../../SkeletonLoaders/ResultSkele.vue";
import GMapView from "../../GMap/GMapView.vue";
import HotelFiltersDropdowns from "../../Filters/HotelFiltersDropdowns";
import RefreshResults from "../RefreshResults";

export default {
  name: "HotelResults",
  mixins: [bookingMixin],
  components: {
    HResult,
    ResultSkele,
    GMapView,
    RefreshResults,
    HotelFiltersDropdowns,
    SearchErrorMessage,
  },
  props: {
    formData: {
      type: Object,
    },
  },
  data: function() {
    return {
      loading: true,
      error: false,
      errors: [],
      searchDetails: null,
      refreshDialogComp: null,
      filters: {
        'sortOrder': "Proximity",
        //sortOrder: "Preferred Vendors",
        selectedChains: [],
        selectedAmenities: [],
        maxPrice: [0, 1500],
        minPolicy: "",
        minRating: "",
      },
      resultProgress: 0,
      selectedHotelCode: null,
      breakfastIncluded: false,
      moreFilters: false,
      fullChainsList: false,
      mobileFiltersModal: false,
      addingData: false,
      no_results: false,
      //fullAmenities: {},
      display_search: false,
      bedFilters: { type: false, quantity: 0 },
      first_selected: false,
      results_loaded: 100,
      maxItemsToAutoload: 10,
      //hotelImages: {},
      //amenitiesByHotelCode: {},
      //roomsByHotelCode: {},
      guaranteeType: "",
      expandedItems: [],
      session: "",
      avalLogos: [],
      items: [],
      additionalItems: [],
      skelItems: [{}, {}, {}, {}],
      refreshTimer: null,
      maxPrice: "",
      showRefreshNotification: false,
      highlightedFilters: {
        sorting: false,
        policy: false,
        price: false,
        amenities: false,
      },
      originalPriceRange: [],
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    ...mapState(["bookTravel"]),
    meetingHotelsResults() {
      return this.$route.name == "MeetingsHotelResults";
    },
    hotelDetailsAlt() {
      return this.formData;
    },
    sortOptions(){
          let options = [
            {value: 'Proximity', label: 'Proximity'},
            {value: 'Alphabetical', label: 'Alphabetical (A to Z)'},
          ];

          if (this.preferredVendors.length > 0){
            options.push({value: 'Preferred Vendors', label: 'Preferred Vendors'});
          }
          return options;
        },
    sliderData() {
      var data = this.filterItems("price").map((x) => x.cheapestPrice);
      data = data.filter((i) => {
        return i < 1500;
      });
      data.sort((a, b) => a - b);
      return data;
    },
    histoMinMax() {
      var arr = this.sliderData;
      arr.sort((a, b) => a - b);
      var min = arr[0];
      var max = arr[arr.length - 1];
      return [min, max];
    },
    fullAmenities() {
      let items = this.items;
      let fullAmenities = {};

      items.forEach((item) => {
        let amenities = item.description?.amenities;
        if (amenities) {
          for (var i = 0; i < amenities.length; i++) {
            fullAmenities[amenities[i]] =
              (fullAmenities[amenities[i]] || 0) + 1;
          }
        }
      });

      return fullAmenities;
    },
    filteredAmenities() {
      let items = this.filterItems();
      let filteredAmenities = {};

      items.forEach((item) => {
        let amenities = item.description?.amenities;
        if (amenities) {
          for (var i = 0; i < amenities.length; i++) {
            filteredAmenities[amenities[i]] =
              (filteredAmenities[amenities[i]] || 0) + 1;
          }
        }
      });
      return filteredAmenities;
    },
    /*
    amenitiesByHotelCode() {
      let obj = {};
      this.items.forEach((hotel) => {
        obj[hotel.hotelCode] = hotel.description?.amenities;
      });
      return obj;
    },
    */
    priceRange() {
      return this.getPriceRange(this.filterItems("price"));
    },
    availablePolicies() {
      return this.getPolicies(this.filteredItems);
    },
    priceData() {
      return this.items.map((x) => parseInt(x.cheapestPrice));
    },
    hotelImages() {
      let obj = {};
      this.items.forEach((hotel) => {
        obj[hotel.hotelCode] = this.parseImage(hotel);
      });
      return obj;
    },
    availableChains() {
      var chains = {};
      this.items.forEach((hotel) => {
        var chain = this.$helpers.capitalize(hotel.chainName);
        if (chain) {
          chains[chain] = (chains[chain] || 0) + 1;
        }
      });
      return chains;
    },
    filteredChains() {
      var chains = {};
      this.filteredItems.forEach((hotel) => {
        var chain = hotel.chainName;
        if (chain) {
          chains[chain] = (chains[chain] || 0) + 1;
        }
      });
      return chains;
    },
    filteredItems() {
      return this.filterItems();
    },
    sortOrder() {
      return this.filters.sortOrder;
    },
    updatedPolicyFilter() {
      return this.filters.minPolicy;
    },
    updatedMaxPrice0() {
      return this.filters.maxPrice[0];
    },
    updatedMaxPrice1() {
      return this.filters.maxPrice[1];
    },
    updatedAmenitiesFilter() {
      return this.filters.selectedAmenities;
    },
    mapView() {
      return this.bookTravel.showMapView.hotel;
    },
    showErrors() {
      return this.errors.length > 0 || this.items.length == 0;
    },
    profile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
    preferredVendors() {
      return this.profile.preferredHotelVendors || [];
    },

  },
  methods: {
    filterItems(category = null) {
      let items = JSON.parse(JSON.stringify(this.items));
      //console.log(items);

      if (this.selectedHotelCode) {
        //items = items.filter((i) => {
        //  return i.hotelCode == this.selectedHotelCode;
        //});
        let selectedIndex = items.findIndex((i) => {
          return i.hotelCode == this.selectedHotelCode;
        });

        //Move selected item to top of list
        items.unshift(items.splice(selectedIndex, 1)[0]);
      }

      if (this.filters.selectedAmenities.length > 0) {
        items = items.filter((i) => {
          return this.amenitiesFilterHelper(i);
        });
      }

      /*MT - removed price filters for now
      if (
        this.filters.maxPrice &&
        category != "price" &&
        !(
          this.filters.maxPrice[0] == this.priceRange[0] &&
          this.filters.maxPrice[1] == this.priceRange[1]
        )
      ) {
        items = items.filter((i) => {
          return (
            i.cheapestPrice <= this.filters.maxPrice[1] &&
            i.cheapestPrice >= this.filters.maxPrice[0]
          );
        });
      }
      */

      if (this.filters.minRating) {
        items = items.filter((i) => {
          return i.overallScore >= this.filters.minRating;
        });
      }
      if (this.filters.selectedChains.length > 0 && category != "chains") {
        if(this.filters.selectedChains[0]=='Preferred Vendors Only'){
          items = items.filter(item=>this.preferredVendors.includes(item.chainCode));
        }else{
          items = items.filter((i) => {
          return this.filters.selectedChains.includes(this.$helpers.capitalize(i.chainName));
        });
        }
        
      }

      if (this.filters.minPolicy) {
        if (this.filters.minPolicy == 1) {
          items = items.filter((i) => {
            return i.travelPolicy.summary.rulesTriggeredCount == 0;
          });
        } else if (this.filters.minPolicy == 2) {
          items = items.filter((i) => {
            return i.travelPolicy.summary.hardApprovalRequiredCount == 0;
          });
        }
      }

      /*
      items = items.filter((i) => {
        return i.rooms.length > 0;
      });
      */

      return items;
    },
    setDefaultFilters(showRestoreMessage = true) {
      if (showRestoreMessage) {
        this.$buefy.toast.open({
          message: "Please wait while we're restoring defaults",
          type: "is-info",
        });
      }
      this.filters.selectedChains = [];
      this.filters.selectedAmenities = [];
      this.filters.minPolicy = "";
      this.filters.sortOrder = "";

      this.selectedHotelCode = null; //if single hotel is selected (by map), then de-select
    },
    resetFilter(value) {
      // console.log('resetFilter HOTEL: filterType', value);
      switch (value) {
        case "sortOrder":
        case "minPolicy":
        case "minRating":
          this.filters[value] = "";
          break;
        /*
        case "maxPrice":
          this.filters.maxPrice[0] = this.bookTravel.hotelDetails.originalPriceRange[0];
          this.filters.maxPrice[1] = this.bookTravel.hotelDetails.originalPriceRange[1];
          this.highlightedFilters.price = false;
          break;
          */
        default:
          this.setDefaultFilters();
          this.highlightedFilters.price = false;
      }
    },
    getHotelAmenities(item) {
      let obj = {};
      this.items.forEach((hotel) => {
        obj[hotel.hotelCode] = hotel.description?.amenities;
      });
      return obj;
    },
    getPriceRange(items) {
      let range = [];

      if (items) {
        if (items.length) {
          range = [items[0].cheapestPrice, items[0].cheapestPrice];
          for (let i = 1; i < items.length; i++) {
            var price = items[i].cheapestPrice;
            if (price < range[0]) {
              range[0] = price;
            } else if (price < 1500 && price > range[1]) {
              range[1] = price;
            }
          }
          // range[0] = Math.floor(range[0] / 100)
          // range[1] = Math.min(range[1], 1500)
        }
      }
      return range;
    },
    getPolicies(items) {
      let policies = {};
      if (items) {
        if (items.length) {
          for (let i = 0; i < items.length; i++) {
            if (items[i].travelPolicy) {
              if (items[i].travelPolicy.summary.rulesTriggeredCount == 0) {
                policies.none = true;
                policies.soft = true;
                break;
              } else if (
                items[i].travelPolicy.summary.hardApprovalRequiredCount == 0
              ) {
                policies.soft = true;
              }
            }
          }
        }
      }
      return policies;
    },
    getChains(items) {
      let vendors = this.$globals.vendors;
      let carriersList = ['Preferred Vendors Only'];
      if (items) {
        for (let i = 0; i < items.length; i++) {
          var carrier;
          carrier = items[i].chainCode;
          if (!carriersList.includes(carrier) && carrier != "") {
            carriersList.push(carrier);
          }
        }
        return carriersList.sort(function(a, b) {
          if (vendors.hotelChains[a] < vendors.hotelChains[b]) {
            return -1;
          } else {
            return 1;
          }
          // return vendors.carProviders[a] - vendors.carProviders[b]
        });
      } else {
        return [];
      }
    },
    parseImage(result) {
      var url = "/images/defaultHotel.jpg";
      let hotel = result?.description?.imagesAndDescriptions?.hotel;

      if (hotel) {
        let images = hotel.images;

        if (images) {
          let image = images[0];
          //console.log(image);
          if (image.url != null) {
            url = image.url;
          }
        }
      }
      return url;
    },
    expandResults() {
      this.items = this.items.concat(this.additionalItems);
      this.sort();
      this.additionalItems = [];
    },
    //append live room rates and cheapest price data to items
    setLiveData(payload) {
      let index = this.items.findIndex((i) => i.hotelCode == payload.hotelCode);

      this.$set(this.items[index], "session", payload.session);

      if (payload.data) {
        //this.items[index] = Object.assign(this.items[index], payload.data[0]);
        let liveData = payload.data[0];

        // MT - only the properties specifically assigned below will be updated
        // add any properties you want to be updated with live data below
        this.$set(this.items[index], "rooms", liveData.rooms);
        this.$set(this.items[index], "cheapestPrice", liveData.cheapestPrice);
        this.$set(this.items[index], "travelPolicy", liveData.travelPolicy);
      } else {
        //if data is null, set item.rooms to empty array so we can indicate no availability found
        this.items[index].rooms = [];
      }
    },
    roomsCount(hotel) {
      if (hotel.rooms) {
        return hotel.rooms?.length;
      } else {
        return null;
      }
    },
    selectedByMap(code) {
      this.closeMapView("hotel");
      this.selectedHotelCode = code;
    },
    //Load list of hotels and descriptions
    async getData(
      refresh = false,
      additionalSearch = false,
      moreIndicator = null
    ) {

      if (!additionalSearch) {
        this.loading = true;
        this.error = false;
        this.errors = [];
        this.resultProgress = 20;
        this.items = [];
      }

      this.searchDetails = this.formData;
      let query = this.formData;
      //console.log('query before', query);

      let lat;
      let lng;

      if (this.formData.loc.geometry) {
        lat = this.formData.loc.geometry.location.lat;
        lng = this.formData.loc.geometry.location.lng;
      }
      if (this.formData.loc.geocode) {
        lat = this.formData.loc.geocode.latitude;
        lng = this.formData.loc.geocode.longitude;
      }
      if (this.formData.loc.lat) {
        lat = this.formData.loc.lat;
        lng = this.formData.loc.lng;
      }

      lat = parseFloat(lat).toFixed(5);
      lng = parseFloat(lng).toFixed(5);

      let body = {
        stateful: true,
        sessionKey: null,
        travelerContactId: this.$globals.travellerProfile.id,
        normalizeResponse: true,
        requestedCurrency: "USD",
        moreIndicator: moreIndicator,
        bestRateOnly: true,
        checkInDate: moment(this.formData.checkinDate).format("YYYY-MM-DD"),
        checkOutDate: moment(this.formData.checkoutDate).format("YYYY-MM-DD"),
        roomCount: 1,
        guestCount: 1,
        location: {
          coordinates: {
            latitude: Number(lat),
            longitude: Number(lng),
          },
          radius: {
            distance: 10,
            distanceUnit: "miles",
          },
        },
      };
      if (
        this.$store.getters["travellersAndTrips/getTravellers"].tripType ===
        "business"
      ) {
        body.travelPolicyId = this.$globals.travellerProfile.travelPolicyId;
      }
      if (query.usedAdvanced === true) {
        body.location.radius.distance = query.radius;
        if (query.star !== "No Preference") {
          body.rating = {
            provider: "LSR",
            value: query.star,
          };
        }
        if (this.formData.advancedSettings.chain !== []) {
          body.chainCodes = [];
          for (const [key, value] of this.formData.advancedSettings.chain) {
            body.chainCodes.push(key);
          }
        }
      }

      //Retrieve list of hotel properties from MongoDB (along with hotel descriptions from HuddleLabs cache)
      let result = await this.$app.huddleLabsServerCall(
        "amadeus/hotel/properties",
        body
      );

      this.loading = false;

      if (result.data && result.data.length > 0) {
        if (additionalSearch) {
          this.items = this.items.concat(result.data);
        } else {
          //this.session = result.meta.sessionKey;
          this.items = result.data;
        }

        let hotelsWithoutDescriptions = result.data.filter((hotel) => {
          return hotel.description == null;
        });

        let hotelCodes = hotelsWithoutDescriptions.map((hotel) => {
          return hotel.hotelCode;
        });

        this.getDescriptions(hotelCodes).then(() => {
          this.finalizeItemsLoading("hotel");
        });

        //this.finalizeItemsLoading("hotel");

        if (result.meta.moreIndicator) {
          this.getData(false, true, result.meta.moreIndicator);
          this.resultProgress = (this.resultProgress + 100) / 2;
        }

        this.resultProgress = 100;
      } else if (result.errors) {
        //no results, show json error message returned from server
        let errors = Object.entries(result.errors);
        this.errors.push(errors);
      } else if (result.message) {
        //else server error message
        let errors = { title: result.message };
        this.errors.push(errors);
      } else {
        //slse default error message
        let errors = { title: "Search failed or no results found." };
        this.errors.push(errors);
      }

      // console.log('result of hotel getData()', result);
    },
    /*    
    //Get live room rates & availabilty and add data to items    
    async getLiveRates(body, hotels) {
      console.log("requesting live data");

      let startDate = moment(this.hotelDetailsAlt.startDate).format(
        "YYYY-MM-DD"
      );
      let endDate = moment(this.hotelDetailsAlt.endDate).format("YYYY-MM-DD");

      body.hotelCodes = hotels;

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/hotel/search",
        body
      );

      this.updateItems(result.data);
    },
    updateItems(data) {
      //existing items
      var items = this.items;

      data.forEach((obj) => {
        let index = items.findIndex((el) => el.hotelCode == obj.hotelCode);

        if (index > -1) {
          items.splice(index, 1, obj);
        }
      });
    },
    */
    //Get hotel descriptions (including images) from Amadeus
    //MT - Most descriptions are retrieved on the inital call to hotel/properties,
    // so we only request those descriptions that were not already stored in our Cache
    async getDescriptions(codes, newHotels = []) {
      let raw = {
        stateful: false,
        sessionKey: null,
        normalizeResponse: true,
        hotelCodes: codes,
        infoToReturn: ["generalInfo", "guestRooms", "multimedia"],
      };

      await this.$app
        .huddleLabsServerCall("amadeus/hotel/description", raw)
        .then((result) => {
          if (result.data && result.data.length > 0) {
            this.resultProgress = (this.resultProgress + 100) / 2;

            //append descriptions to existing hotel items
            this.appendDescriptions(result.data);
            this.sort();
          }

          this.addingData = false;
        });
    },
    //Append hotel descriptions to each element of items array
    appendDescriptions(descriptions) {
      descriptions.forEach((desc) => {
        let index = this.items.findIndex(
          (el) => el.hotelCode == desc.hotelData.hotelCode
        );

        if (index > -1) {
          this.items[index].description = desc;
        }
      });
    },
    amenitiesFilterHelper(item) {
      var val;
      for (val of this.filters.selectedAmenities) {
        if (!(item.description?.amenities.indexOf(val) >= 0)) {
          return false;
        }
      }
      return true;
    },
    /*
    buildImageDict(images) {
      for (let hotel = 0; hotel < images.length; hotel++) {
        // // console.log(images[hotel].imagesAndDescriptions.hotel.images)
        if (images[hotel].imagesAndDescriptions.hotel.images) {
          this.hotelImages[images[hotel].hotelData.hotelCode] =
            images[hotel].imagesAndDescriptions.hotel.images[0].url;
        } else {
          this.hotelImages[images[hotel].hotelData.hotelCode] =
            "/images/defaultHotel.jpg";
        }
      }
    }, 
    */
    sort() {
      this.selectedHotelCode = null; //if single hotel is selected by map, deselect before sorting

      if (this.filters.sortOrder == "Price Asc") {
        this.items.sort((a, b) => {
          return a.cheapestPrice - b.cheapestPrice;
        });
      } 
      else if (this.filters.sortOrder == "Preferred Vendors") {

          this.items.sort((a, b) => {
              return  ( this.preferredVendors.includes(a.chainCode) ) ? -1 :( this.preferredVendors.includes(b.chainCode) )? 1:0;
          });
          }
      else if (this.filters.sortOrder == "Price Desc") {
        this.items.sort((a, b) => {
          return b.cheapestPrice - a.cheapestPrice;
        });
      } else if (this.filters.sortOrder == "Alphabetical") {
        this.items.sort((a, b) => {
          return a.hotelName > b.hotelName ? 1 : -1;
        });
      } else if (this.filters.sortOrder == "Proximity") {
        this.items.sort((a, b) => {
          return (
            a.distanceFromSearchedLocation - b.distanceFromSearchedLocation
          );
        });
      } else {
        this.items.sort((a, b) => {
          // return a.journeys[0].travelDuration - b.journeys[0].travelDuration
          // let a_tot = 0;
          // let b_tot = 0;
          // for (var i = 0; i < a.journeys.length; i++) {
          //   a_tot += a.journeys[i].travelDuration
          //   b_tot += b.journeys[i].travelDuration
          // }
          // return a_tot - b_tot;

          // Sort by cheapest
          // return a.cheapestPrice - b.cheapestPrice;

          // Sort by distance
          return (
            a.distanceFromSearchedLocation - b.distanceFromSearchedLocation
          );
        });
      }
    },
  },
  watch: {
    //uses a deep watcher to trigger call to this.getData() upon receiving a HotelForm submit/update
    formData: {
      handler(newVal, prevVal) {
        this.showRefreshNotification = false;
        this.getData();
      },
      deep: false,
    },
    showRefreshNotification(newVal, prevVal) {
      this.setSearchRecordsStatus("hotel", newVal);
    },
    sortOrder() {
      if (this.sortOrder === "" || this.sortOrder === null) {
        this.highlightedFilters.sorting = false;
      } else {
        this.highlightedFilters.sorting = true;
      }

      this.sort();
    },
    loading() {
      this.sort();
    },
    updatedPolicyFilter(newVal, prevVal) {
      newVal !== ""
        ? (this.highlightedFilters.policy = true)
        : (this.highlightedFilters.policy = false);
    },
    /*
      updatedMaxPrice0(newVal, prevVal){
        // console.log('watching updatedMaxPrice0', this.filters);
        // console.log('prevVal:', JSON.stringify(prevVal));
        // console.log('newVal:', JSON.stringify(newVal));
        // console.log('this.bookTravel.originalPriceRange[0]', this.bookTravel.hotelDetails.originalPriceRange[0]);

        ( (newVal !== this.bookTravel.hotelDetails.originalPriceRange[0]) || this.bookTravel.hotelDetails.originalPriceRange[1] !== this.filters.maxPrice[1] )
            ? this.highlightedFilters.price = true
            : this.highlightedFilters.price = false;
      },
      updatedMaxPrice1(newVal, prevVal){
        // console.log('watching updatedMaxPrice1', this.filters);
        // console.log('prevVal:', JSON.stringify(prevVal));
        // console.log('newVal:', JSON.stringify(newVal));
        // console.log('this.bookTravel.originalPriceRange[1]', this.bookTravel.hotelDetails.originalPriceRange[1]);

        (newVal !== this.bookTravel.hotelDetails.originalPriceRange[1] || this.bookTravel.hotelDetails.originalPriceRange[0] !== this.filters.maxPrice[0])
            ? this.highlightedFilters.price = true
            : this.highlightedFilters.price = false;
      },
      */
    updatedAmenitiesFilter(newVal, prevVal) {
      newVal.length > 0
        ? (this.highlightedFilters.amenities = true)
        : (this.highlightedFilters.amenities = false);
    },
  },
  mounted() {
    this.setSearchRecordsStatus("hotel", this.showRefreshNotification);
    this.originalPriceRange = this.priceRange;
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
    this.getData();
    
    //show preferred vendor results first
    if (this.preferredVendors.length > 0) {
      this.filters.sortOrder = "Preferred Vendors";
    }
  },
  beforeDestroy() {
    if (this.refreshDialogComp) {
      this.refreshDialogComp.close();
    }
    clearTimeout(this.refreshTimer);
  },
};
</script>

<style lang="scss">
.infoi {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.infok {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.infoj {
  position: fixed;
  bottom: 0%;
  left: 256px;
  z-index: 3;
  // transform: translate(0%, -50%);
}
div.grayout .property_image {
  opacity: 0.6;
  filter: alpha(opacity = 60); /* MSIE */
}
div.grayout .property_name {
  opacity: 0.6;
  filter: alpha(opacity = 60); /* MSIE */
}
</style>
